(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nara-media-grid"] && !Shopify.designMode) return;
  try {
    
  /**
   * NARA KNITS — Media Grid Slideshow
   * Auto-play crossfade, fără săgeți/buline.
   * Viteza se citește din data-speed (secunde per slide).
   */
  (function () {
    'use strict';

    /** Pornește toate slideshow-urile dintr-un container */
    function initSlideshows(root) {
      root.querySelectorAll('.nara-mgrid__slideshow').forEach(function (ss) {
        var slides = Array.from(ss.querySelectorAll('.nara-mgrid__slide'));
        if (slides.length < 2) return;

        var speed  = parseFloat(ss.dataset.speed) || 3;  // secunde
        var delay  = speed * 1000;                        // ms
        var current = 0;

        // Curăță orice timer anterior (re-init în theme editor)
        if (ss._naraTimer) clearInterval(ss._naraTimer);

        ss._naraTimer = setInterval(function () {
          slides[current].classList.remove('is-active');
          slides[current].setAttribute('aria-hidden', 'true');

          current = (current + 1) % slides.length;

          slides[current].classList.add('is-active');
          slides[current].setAttribute('aria-hidden', 'false');
        }, delay);
      });
    }

    /** Oprește slideshow-urile dintr-un container (la unmount) */
    function destroySlideshows(root) {
      root.querySelectorAll('.nara-mgrid__slideshow').forEach(function (ss) {
        if (ss._naraTimer) {
          clearInterval(ss._naraTimer);
          ss._naraTimer = null;
        }
      });
    }

    /* ——— Init la încărcarea paginii ——— */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initSlideshows(document);
      });
    } else {
      initSlideshows(document);
    }

    /* ——— Re-init în Theme Editor (la schimbarea setărilor) ——— */
    document.addEventListener('shopify:section:load', function (e) {
      initSlideshows(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      destroySlideshows(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var ss = e.target.querySelector('.nara-mgrid__slideshow');
      if (ss) initSlideshows(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
